'use client';

import type { RumInitConfiguration } from '@datadog/browser-rum';
import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { DatadogAppRouter } from '@datadog/browser-rum-nextjs';
import { initialize, resetRumTimingsForNewView } from '@/utils/datadog';

export const DatadogRumInitializer: React.FC<RumInitConfiguration> = (config) => {
    const pathname = usePathname();
    const [rumReady, setRumReady] = useState(false);

    // nextjsPlugin() enables manual views. DatadogAppRouter calls startView during render,
    // which no-ops until RUM init completes — mount it only after init so the initial view
    // exists and SDK CWV (LCP/INP/CLS) attach to @type:view events.
    useEffect(() => {
        initialize(config);
        setRumReady(true);
    }, [config]);

    useEffect(() => {
        resetRumTimingsForNewView();
    }, [pathname]);

    return rumReady ? <DatadogAppRouter /> : null;
};
